import Vue from 'vue'
import store from '@/store'


Vue.mixin({

    methods: {

        isRole(role){
            if (store.state.auth.roles.includes(role) || store.state.auth.roles.includes('superadmin')) {
                return true;
            } else {
                return false
            }
        },
        hasPermission(permission) {
            return store.state.auth.permissions && store.state.auth.permissions.includes(permission)
        },
        isNotUser() {
            return this.isRole('serviceperson') || this.isRole('developer') || this.isRole('superadmin') || this.isRole('gatekeeper')
        },
        getAbbreviation(text) {
            if(!text){
                text = 'N/A'
            }
            let words = text.replace(/[^a-zA-Z ]/g, "").split(' ')
            if(words.length==1){
                return words[0].substring(0,2).toUpperCase()
            }else{
                return (words[0].substring(0,1) + words[words.length-1].substring(0,1)).toUpperCase()
            }
        },
        getIcon(type) {
            var icon = null
            switch(type) {
                case 'Bug Report':
                    icon = 'mdi-bug'
                    break
                case 'Feature Suggestion':
                    icon = 'mdi-card-text'
                    break
                case 'Service Request':
                    icon = 'mdi-comment-alert'
                break;
            }
            return icon
        },


    }

})
